//dependencias
import React, { Component } from 'react';

//componentes
import EsperaAction from './Espera'

class Espera extends Component {

    render(){
        return(
            <div>
                <EsperaAction />
            </div>
        );
    }

}
export default Espera;